import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["openTwoFactorRecovery", "precedence", "setPrecedence", "authMethod", "hasSecondaryMethod"];
import { useEffect, useState } from 'react';
import TwoFactorAuthMethod from '../../constants/twoFactorAuthMethod';
import I18n from 'I18n';
import PrecedenceLevels from '../../constants/precedenceLevels';
import { checkMobileAuthPressed, tryAuthentication, resendTwoFactor } from '../../data/authentication';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import TwoFactorRequestStatus from '../../constants/TwoFactorRequestStatus';
import ErrorTypes from '../../constants/ErrorTypes';
import fetchTwoFactorMethod from '../../data/fetchTwoFactorMethod';
import HelpMeSection from './HelpMeSection';
import TwoFactorForm from './TwoFactorForm';
import PromptWrapper from './PromptWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function TwoFactorPrompt(_ref) {
  let {
      openTwoFactorRecovery,
      precedence,
      setPrecedence,
      authMethod,
      hasSecondaryMethod
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const [canSubmit, setCanSubmit] = useState(false);
  const [email, setEmail] = useState(undefined);
  const [currentCode, setCurrentCode] = useState('');
  const [currentAuthMethod, setCurrentAuthMethod] = useState(authMethod || 'GOOGLE_AUTHENTICATOR');
  const [currentObfuscatedInfo, setCurrentObfuscatedInfo] = useState(props.obfuscatedInfo);
  const [currentError, setCurrentError] = useState('');
  const [codeSentKey, setCodeSentKey] = useState(undefined);
  const [mobileAuthInterval, setMobileAuthInterval] = useState();
  const [intervalShouldRun, setIntervalShouldRun] = useState(true);
  useEffect(() => {
    if (!mobileAuthInterval && intervalShouldRun && props.isOpen && currentAuthMethod === TwoFactorAuthMethod.HUBSPOT_AUTHENTICATOR) {
      setMobileAuthInterval(setInterval(handleMobileInterval, 1000));
    }
    function handleMobileInterval() {
      checkMobileAuthPressed().then(result => {
        if (result === TwoFactorRequestStatus.APPROVED) {
          tryAuthentication({
            authMethod: currentAuthMethod,
            twoFactorLevel: precedence,
            mobilePush: true
          }).then(() => {
            props.onSuccess(...(props.argArray !== undefined ? props.argArray : []));
          }).catch(err => {
            setCurrentError(err.message);
            setIntervalShouldRun(false);
            clearTimeout(mobileAuthInterval);
          });
        }
      }).catch(() => {
        setCurrentError(ErrorTypes.INVALID_MOBILE_AUTH);
        setIntervalShouldRun(false);
        clearTimeout(mobileAuthInterval);
      });
    }
    return () => {
      if (mobileAuthInterval) {
        clearTimeout(mobileAuthInterval);
      }
    };
  }, [props, mobileAuthInterval, intervalShouldRun, currentAuthMethod, precedence]);
  function codeLength() {
    return currentAuthMethod === TwoFactorAuthMethod.BACKUP_CODE ? 10 : 6;
  }
  function formOnChange(ev) {
    const code = ev.target.value.replace(/\s/g, '').slice(0, codeLength());
    ev.target.value = code;
    setCurrentCode(code);
    setCanSubmit(code.length === codeLength());
  }
  function formOnSubmit(ev) {
    ev.preventDefault();
    tryAuthentication({
      authMethod: currentAuthMethod,
      code: currentCode,
      twoFactorLevel: precedence
    }).then(() => {
      props.onSuccess(...(props.argArray !== undefined ? props.argArray : []));
    }).catch(err => {
      setCurrentError(err.message);
    });
  }
  function onChangePrecedence() {
    const newPrecedence = precedence === PrecedenceLevels.PRIMARY ? PrecedenceLevels.SECONDARY : PrecedenceLevels.PRIMARY;
    setEmail(undefined);
    setPrecedence(newPrecedence);
    fetchTwoFactorMethod(newPrecedence).then(methodData => {
      if (methodData) {
        const validatedMethod = methodData.method;
        setCurrentAuthMethod(validatedMethod);
        setCurrentObfuscatedInfo(methodData.obfuscatedInfo || '');
        setMobileAuthInterval(undefined);
      }
    }).catch(() => {
      FloatingAlertStore.addAlert({
        titleText: I18n.text('reAuth.error.FALLBACK.title'),
        message: I18n.text('reAuth.error.FALLBACK.descTwo'),
        type: 'danger'
      });
    });
  }
  function retryCode() {
    setEmail(undefined);
    resendTwoFactor(precedence === PrecedenceLevels.PRIMARY).then(res => {
      setCodeSentKey(res.key);
      if (res.emailInfo) {
        setEmail(res.emailInfo);
      }
    }).catch(err => setCurrentError(err.message));
  }
  return /*#__PURE__*/_jsxs(PromptWrapper, {
    currentAuthMethod: currentAuthMethod,
    currentObfuscatedInfo: currentObfuscatedInfo,
    children: [/*#__PURE__*/_jsx(TwoFactorForm, {
      currentAuthMethod: currentAuthMethod,
      formOnSubmit: formOnSubmit,
      codeLength: codeLength(),
      formOnChange: formOnChange,
      code: currentCode,
      canSubmit: canSubmit,
      openTwoFactorRecovery: openTwoFactorRecovery,
      currentError: currentError,
      setCurrentError: setCurrentError,
      codeSentKey: codeSentKey,
      email: email,
      currentObfuscatedInfo: currentObfuscatedInfo,
      setCodeSentKey: setCodeSentKey,
      retryCode: retryCode
    }), /*#__PURE__*/_jsx(HelpMeSection, {
      currentAuthMethod: currentAuthMethod,
      precedence: precedence,
      setCodeSentKey: setCodeSentKey,
      setCurrentError: setCurrentError,
      setCurrentAuthMethod: setCurrentAuthMethod,
      openTwoFactorRecovery: openTwoFactorRecovery,
      onChangePrecedence: onChangePrecedence,
      setMobileAuthInterval: setMobileAuthInterval,
      authMethod: authMethod,
      hasSecondaryMethod: hasSecondaryMethod
    })]
  });
}